import styled from 'styled-components/macro';

export const Wrapper = styled.div<{ isDisabled?: boolean }>`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  width: 90%;
  pointer-events: ${(props) => (props.isDisabled ? 'none' : 'auto')};
`;
